import { useEffect, useState } from 'react';

import Spinner from '../../reusable/spinner/spinner.component.jsx';
import Client from '../../../tools/client.js';
import Tools from '../../../tools/tools.js';

import { Table, Th, Td, TotalHighlight } from './pull-sheet.styles.jsx';

const client = new Client();
const tools = new Tools();

const PullSheet = () => {
  const [pullData, setPullData] = useState([]);
  const [orderBreakdown, setOrderBreakdown] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPullSheet();
  }, []);

  const getPullSheet = async () => {
    setLoading(true);
    const res = await client.getPullSheet();

    setPullData(res.pullSummary || []);
    setOrderBreakdown(res.breakdownByOrder || []);
    setLoading(false);
  };

  if (loading) return <Spinner />;
  if (pullData.length === 0) return <div>No unshipped items to pull.</div>;

  return (
    <div>
      <h1>Inventory Pull Sheet</h1>

      {/* Inventory Summary */}
      <Table>
        <thead>
          <tr>
            <Th>Product</Th>
            <Th>Inventory ID</Th>
            <Th>Size</Th>
            <Th>New/Billed</Th>
            <Th>Paid/Processing</Th>
            <Th>Total to Pull</Th>
          </tr>
        </thead>
        <tbody>
          {pullData.map(item => (
            <tr key={item.inventoryId}>
              <Td>{item.productName}</Td>
              <Td>{item.inventoryId || '-'}</Td>
              <Td>{item.inventoryDetails?.size || '-'}</Td>
              <Td>{item.fromNewOrBilled}</Td>
              <Td>{item.fromPaidOrProcessing}</Td>
              <Td><TotalHighlight>{item.totalToPull}</TotalHighlight></Td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Order Breakdown */}
      <h2 style={{ marginTop: '2rem' }}>Order Breakdown</h2>
      <Table>
        <thead>
          <tr>
            <Th>Order</Th>
            <Th>Inventory ID</Th>
            <Th>Quantity</Th>
            <Th>Status</Th>
            <Th>Created At</Th>
          </tr>
        </thead>
        <tbody>
          {orderBreakdown.map(order =>
            order.products.map((prod, idx) => (
              <tr key={`${order.id}-${prod.inventoryId}`}>
                <Td>
                  {idx === 0 ? (
                    <a href={`/orders/${order.id}`} target="_blank" rel="noopener noreferrer">
                      #{order.id}
                    </a>
                  ) : ''}
                </Td>
                <Td>{prod.inventoryId}</Td>
                <Td>{prod.quantity}</Td>
                <Td>{idx === 0 ? order.status : ''}</Td>
                <Td>{idx === 0 ? tools.formatDate(order.createdAt) : ''}</Td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default PullSheet;